<template>
    <div class="paddingBox">
        <div class="d-flex align-items-center justify-content-between mb-20">
            <h2 class="mb-0">Zoznam žiakov</h2>
        </div>
        <div class="rounded-box --whiteBg p-50">
            <form @submit.prevent="addZiak">
                <div class="form-row">
                    <div class="col-12 col-md-12">
                        <label for="pridat-ziaka">Pridať žiaka do zoznamu</label>
                        <div class="position-relative ziak-input-group">
                            <input type="text" class="form-control form-control-lg" name="pridat-ziaka" id="pridat-ziaka" v-model="novyZiak">
                            <button class="btn --secondary" type="submit">pridať žiaka</button>
                        </div>
                    </div>
                </div>

                <div class="form-row mb-30">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center justify-content-between mb-15">
                            <p class="text-uppercase mb-0"><b class="text-dark">zoznam pridaných žiakov</b></p>
                            <p class="mb-0">Pridaných žiakov: <b class="text-primary">{{ this.form.pouzivatel_ziaci.length }}</b></p>
                        </div>

                        <ul class="list-ziakov mb-0">
                            <li v-for="(ziak, index) in form.pouzivatel_ziaci">
                                <p class="mb-0"><span class="icon icon--user mr-15 text-icon"></span><b>{{ ziak }}</b></p>
                                <p class="mb-0 remove-item cursor-pointer" @click="removeZiak(index)">
                                    <span class="text-primary text-underline">Odstrániť žiaka</span>
                                    <span class="icon icon--delete text-primary ml-10"></span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-12">
                        <div class="separator"></div>
                    </div>
                </div>

                <div class="form-row mb-0">
                    <div class="col-12 col-md-12 text-right">
                        <div class="d-flex align-items-center justify-content-between">
                            <span class="text-primary text-underline cursor-pointer" @click="$emit('updateStep', 'kolektiv')">Späť na prvý krok</span>
                            <button :disabled="!form.pouzivatel_ziaci.length" @click="$emit('updateStep', 'zhrnutie')" class="btn --primary">pokračovať na zhrnutie</button>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </div>
</template>



<script>
    export default {
        props: {
            form: {
                type: Object,
                required: true
            }
        },
        computed: {},
        data() {
            return {
                novyZiak: ''
            }
        },
        methods: {
            addZiak() {
                if ( this.novyZiak.trim() ) {
                    this.form.pouzivatel_ziaci.push( this.novyZiak )
                    this.novyZiak = ''
                }
            },

            removeZiak(index) {
                this.form.pouzivatel_ziaci.splice(index, 1)
            },
        }
    }
</script>
